import script from "./AboutBio.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutBio.vue?vue&type=script&setup=true&lang=js"

import "./AboutBio.vue?vue&type=style&index=0&id=0bd3f4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd3f4a0"]])

export default __exports__